import { atom } from "nanostores";

type MobileNavigationState = {
  isOrgPopoverOpen: boolean;
  isNavOpen: boolean;
  isSettingsOpen: boolean;
};

const initialState: MobileNavigationState = {
  isOrgPopoverOpen: false,
  isNavOpen: false,
  isSettingsOpen: false,
};

export const $mobileNavigation = atom<MobileNavigationState>(initialState);

export const mobileNavigationActions = {
  closeOrgPopover: () => {
    $mobileNavigation.set({
      ...$mobileNavigation.get(),
      isOrgPopoverOpen: false,
    });
  },
  toggleOrgPopover: () => {
    const currentState = $mobileNavigation.get();
    $mobileNavigation.set({
      ...currentState,
      isOrgPopoverOpen: !currentState.isOrgPopoverOpen,
      isNavOpen: false,
      isSettingsOpen: false,
    });
  },
  toggleNav: () => {
    const currentState = $mobileNavigation.get();
    $mobileNavigation.set({
      ...currentState,
      isNavOpen: !currentState.isNavOpen,
      isOrgPopoverOpen: false,
      isSettingsOpen: false,
    });
  },
  closeNav: () => {
    $mobileNavigation.set({ ...$mobileNavigation.get(), isNavOpen: false });
  },
  toggleSettings: () => {
    const currentState = $mobileNavigation.get();
    $mobileNavigation.set({
      ...currentState,
      isSettingsOpen: !currentState.isSettingsOpen,
      isOrgPopoverOpen: false,
    });
  },
  closeSettings: () => {
    $mobileNavigation.set({
      ...$mobileNavigation.get(),
      isSettingsOpen: false,
    });
  },
  closeAll: () => {
    $mobileNavigation.set(initialState);
  },
};
